import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.number.is-finite.js";
import "core-js/modules/es.object.from-entries.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { defineComponent as _defineComponent } from 'vue';
import { useShowDebugging } from '~/functions/accounts';
import { getSafe } from '~/functions/helpers';
import { SfdrStrategyKind, TypeAggregationGroup, useDeleteMetricAggregationMutation, useGetAccountQuery, useGetUserQuery, useListMetricAggregationsQuery, useUpdateMetricAggregationMutation } from '~/types/types';
export default /*#__PURE__*/_defineComponent({
  __name: 'MetricAggregations',
  props: {
    height: {
      default: 'calc(100vh - 210px)',
      type: String
    },
    headersProp: {
      required: false,
      type: Array,
      default: function _default() {
        return ['metric.name', 'metric.commaSeparatedSections', 'group', 'unitName', 'valueLegend', 'showPeriodOption', 'action', 'comment'];
      }
    },
    commentHint: {
      require: false,
      type: String,
      default: ''
    },
    filters: {
      required: false,
      type: Object,
      default: function _default() {}
    },
    showSidebar: {
      required: false,
      type: Boolean,
      default: true
    },
    search: {
      required: false,
      type: String,
      default: function _default() {
        return '';
      }
    },
    itemsPerPage: {
      required: false,
      type: Number,
      default: 10
    },
    sortBy: {
      required: false,
      type: Array,
      default: function _default() {
        return ['metric.name'];
      }
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var _useNuxtApp = useNuxtApp(),
      $i18n = _useNuxtApp.$i18n,
      $nuxt = _useNuxtApp.$nuxt;
    var _useGetAccountQuery = useGetAccountQuery(),
      accountResult = _useGetAccountQuery.result;
    var account = computed(function () {
      var _accountResult$value;
      return (_accountResult$value = accountResult.value) === null || _accountResult$value === void 0 ? void 0 : _accountResult$value.getAccount;
    });
    var _useGetUserQuery = useGetUserQuery(),
      userResult = _useGetUserQuery.result;
    var user = computed(function () {
      var _userResult$value;
      return (_userResult$value = userResult.value) === null || _userResult$value === void 0 ? void 0 : _userResult$value.getUser;
    });
    var expandPeriods = ref(false);
    var filteredCategoryIds = ref([]);
    var filteredSectionIds = ref([]);
    var defaultPeriods = computed(function () {
      var _account$value, _account$value$defaul, _account$value2;
      var currentYear = new Date().getFullYear();
      if (((_account$value = account.value) === null || _account$value === void 0 ? void 0 : (_account$value$defaul = _account$value.defaultReferencePeriods) === null || _account$value$defaul === void 0 ? void 0 : _account$value$defaul.length) === 0) {
        return [currentYear - 1, currentYear];
      }
      var annualOnly = (((_account$value2 = account.value) === null || _account$value2 === void 0 ? void 0 : _account$value2.defaultReferencePeriods) || []).filter(function (period) {
        return !String(period).includes(' ');
      });
      if (annualOnly.length === 0) {
        return [currentYear - 1, currentYear];
      }
      return annualOnly.map(function (period) {
        return Number(period);
      }).filter(Number.isFinite);
    });
    var periods = computed(function () {
      return expandPeriods.value ? Array.from({
        length: 11
      }, function (_, index) {
        return 2020 + index;
      }) : defaultPeriods.value;
    });
    var getMetricDefaultReportingPeriodType = function getMetricDefaultReportingPeriodType(item) {
      return item && item.metric ? item.metric.defaultReportingPeriodType : undefined;
    };
    var useTargetFromFilters = computed(function () {
      return props.filters && props.filters.isPaiResultsView ? false : true;
    });
    var options = ref({
      page: 1,
      itemsPerPage: props.itemsPerPage,
      sortBy: props.sortBy,
      sortDesc: [false]
    });
    var expanded = ref([]);
    var showDebugging = useShowDebugging();
    var headers = computed(function () {
      var _defaultPeriods$value;
      var allHeaderByKey = {
        id: {
          width: '20px',
          text: 'MAgg ID',
          value: 'id',
          cellClass: 'font-weight-bold subtitle-2'
        },
        'metric.id': {
          width: '10px',
          text: 'ID',
          value: 'metric.id',
          cellClass: 'font-weight-bold subtitle-2'
        },
        'metric.name': {
          text: $i18n.t('companyPerspective.kpis.headers.kpi'),
          value: 'metric.name',
          cellClass: '',
          width: '200px',
          sortable: true
        },
        'metric.commaSeparatedSections': {
          text: $i18n.t('companyPerspective.kpis.headers.relatedFrameworks'),
          value: 'metric.commaSeparatedSections',
          cellClass: '',
          width: '200px'
        },
        group: {
          text: $i18n.t('companyPerspective.kpis.headers.group'),
          value: 'group',
          cellClass: '',
          width: '200px'
        },
        unitName: {
          text: $i18n.t('companyPerspective.kpis.headers.unit'),
          value: 'unitName',
          cellClass: '',
          width: '100px'
        },
        valueLegend: {
          text: $i18n.t('companyPerspective.kpis.headers.values'),
          value: 'valueLegend',
          cellClass: '',
          width: '80px'
        },
        2020: {
          text: 2020,
          value: 2020,
          cellClass: 'primary--text text-center',
          align: 'center',
          width: '100px'
        },
        2021: {
          text: 2021,
          value: 2021,
          cellClass: 'primary--text text-center',
          align: 'center',
          width: '100px'
        },
        2022: {
          text: 2022,
          value: 2022,
          cellClass: 'primary--text text-center',
          align: 'center',
          width: '100px'
        },
        2023: {
          text: 2023,
          value: 2023,
          cellClass: 'primary--text text-center',
          align: 'center',
          width: '100px'
        },
        2024: {
          text: 2024,
          value: 2024,
          cellClass: 'primary--text text-center',
          align: 'center',
          width: '100px'
        },
        2025: {
          text: 2025,
          value: 2025,
          cellClass: 'primary--text text-center',
          align: 'center',
          width: '100px'
        },
        2026: {
          text: 2026,
          value: 2026,
          cellClass: 'primary--text text-center',
          align: 'center',
          width: '100px'
        },
        2027: {
          text: 2027,
          value: 2027,
          cellClass: 'primary--text text-center',
          align: 'center',
          width: '100px'
        },
        2028: {
          text: 2028,
          value: 2028,
          cellClass: 'primary--text text-center',
          align: 'center',
          width: '100px'
        },
        2029: {
          text: 2029,
          value: 2029,
          cellClass: 'primary--text text-center',
          align: 'center',
          width: '100px'
        },
        2030: {
          text: 2030,
          value: 2030,
          cellClass: 'primary--text text-center',
          align: 'center',
          width: '100px'
        },
        showPeriodOption: {
          text: '',
          value: 'showPeriodOption',
          cellClass: 'align-center subtitle-1 font-weight-bold text-center',
          sortable: false,
          width: '60px'
        },
        action: {
          text: $i18n.t('companyPerspective.kpis.headers.actions'),
          value: 'action',
          cellClass: 'subtitle-1 font-weight-bold',
          width: '100px'
        },
        comment: {
          text: $i18n.t('companyPerspective.kpis.headers.comments'),
          value: 'comment',
          width: '300px',
          cellClass: 'subtitle-1 font-weight-bold'
        }
      };
      var wantedHeaders = _toConsumableArray(props.headersProp);
      if (showDebugging.value) {
        wantedHeaders.unshift('id');
      }
      wantedHeaders.unshift('metric.id');
      if (expandPeriods !== null && expandPeriods !== void 0 && expandPeriods.value) {
        var fullPeriods = periods.value || [];
        insertPeriodHeaders(wantedHeaders, fullPeriods);
      } else if ((defaultPeriods === null || defaultPeriods === void 0 ? void 0 : (_defaultPeriods$value = defaultPeriods.value) === null || _defaultPeriods$value === void 0 ? void 0 : _defaultPeriods$value.length) > 0) {
        insertPeriodHeaders(wantedHeaders, defaultPeriods.value);
      }
      return wantedHeaders.map(function (header) {
        var headerValue = typeof header === 'string' ? header : header.value;
        var headerConfig = allHeaderByKey[headerValue];
        if (!headerConfig) {
          console.error("Header \"".concat(headerValue, "\" does not exist in allHeaderByKey"));
          return null;
        }
        return typeof header === 'string' ? headerConfig : _objectSpread(_objectSpread({}, headerConfig), header);
      }).filter(Boolean);
    });

    // Helper function to insert period headers at the correct position
    var insertPeriodHeaders = function insertPeriodHeaders(headers, periods) {
      if (periods.length === 0) return;

      // Remove any existing year headers (2020-2030)
      for (var i = headers.length - 1; i >= 0; i--) {
        var header = headers[i];
        var headerValue = typeof header === 'string' ? header : header.value;
        var year = parseInt(headerValue);
        if (!isNaN(year) && year >= 2020 && year <= 2030) {
          headers.splice(i, 1);
        }
      }

      // Find insertion point (after valueLegend, before showPeriodOption)
      var valueLegendIndex = headers.findIndex(function (h) {
        var value = typeof h === 'string' ? h : h.value;
        return value === 'valueLegend';
      });
      var insertIndex = valueLegendIndex !== -1 ? valueLegendIndex + 1 : headers.length;

      // Insert period headers
      headers.splice.apply(headers, [insertIndex, 0].concat(_toConsumableArray(periods.map(function (year) {
        return {
          value: year.toString()
        };
      }))));
    };
    var selectedCategoryIdsForFilter = computed(function () {
      return filteredCategoryIds.value.filter(function (id) {
        return id !== 'uncategorized';
      }).map(function (id) {
        return Number(id);
      }).filter(function (id) {
        return Number.isFinite(id);
      });
    });
    var selectedIncludesUncategorized = computed(function () {
      return filteredCategoryIds.value.includes('uncategorized');
    });
    var selectedSectionIdsForFilter = computed(function () {
      return filteredSectionIds.value.map(function (id) {
        return Number(id);
      }).filter(function (id) {
        return Number.isFinite(id);
      });
    });
    var variables = computed(function () {
      return _objectSpread(_objectSpread({}, props.filters), {}, {
        keyword: props.search || '',
        categoryIds: selectedCategoryIdsForFilter.value,
        includeUncategorized: selectedIncludesUncategorized.value,
        sectionIds: selectedSectionIdsForFilter.value,
        offset: options.value.itemsPerPage * (options.value.page - 1),
        limit: options.value.itemsPerPage,
        sort: options.value.sortBy.map(function (item, index) {
          return {
            field: String(item),
            sortDesc: options.value.sortDesc[index]
          };
        })
      });
    });
    var _useListMetricAggrega = useListMetricAggregationsQuery(variables),
      loading = _useListMetricAggrega.loading,
      result = _useListMetricAggrega.result,
      refetch = _useListMetricAggrega.refetch;
    var categoryCounts = computed(function () {
      var _result$value;
      return ((_result$value = result.value) === null || _result$value === void 0 ? void 0 : _result$value.listMetricAggregationCategoryCounts) || [];
    });
    var sectionCounts = computed(function () {
      var _result$value2;
      return ((_result$value2 = result.value) === null || _result$value2 === void 0 ? void 0 : _result$value2.listMetricAggregationSectionCounts) || [];
    });

    // Listen for the refetch event when the component is mounted
    onMounted(function () {
      $nuxt.$on('refetch-metric-aggregations', refetch);
    });

    // Clean up the event listener when the component is unmounted
    onBeforeUnmount(function () {
      $nuxt.$off('refetch-metric-aggregations', refetch);
    });
    var itemCount = computed(function () {
      var _result$value$countMe, _result$value3;
      return (_result$value$countMe = (_result$value3 = result.value) === null || _result$value3 === void 0 ? void 0 : _result$value3.countMetricAggregations) !== null && _result$value$countMe !== void 0 ? _result$value$countMe : 0;
    });
    var items = computed(function () {
      var _result$value$listMet, _result$value4;
      var fromDb = (_result$value$listMet = (_result$value4 = result.value) === null || _result$value4 === void 0 ? void 0 : _result$value4.listMetricAggregations) !== null && _result$value$listMet !== void 0 ? _result$value$listMet : [];
      var data = fromDb.map(function (e) {
        var _item$metricAggregati;
        var item = _objectSpread({}, e);
        item.metricValuesByPeriod = {};
        item.metricValuesByPeriod = Object.fromEntries(
        // This shouldn't be in front end.
        ((_item$metricAggregati = item.metricAggregationValues) === null || _item$metricAggregati === void 0 ? void 0 : _item$metricAggregati.map(function (e) {
          return [e.period, e];
        })) || []);
        item.editable = false; // TODO this is hard coded
        // item.taxonomiesString = extractTaxonomiesAsString(item.metric?.sections)
        return item;
      });
      return data;
    });
    var _useDeleteMetricAggre = useDeleteMetricAggregationMutation({}),
      deleteMetricAggregation = _useDeleteMetricAggre.mutate;
    var _useUpdateMetricAggre = useUpdateMetricAggregationMutation(),
      updateMetricAggregation = _useUpdateMetricAggre.mutate;
    var groupName = function groupName(item) {
      var _item$fund;
      var fundName = (_item$fund = item.fund) === null || _item$fund === void 0 ? void 0 : _item$fund.name;
      var groupInfo = '';
      switch (item.groupType) {
        case TypeAggregationGroup.PortfolioVentureLink:
          return '';
        case TypeAggregationGroup.SfdrStrategy:
          if (item.sfdrStrategy) {
            var _item$sfdrStrategy$fu, _item$sfdrStrategy$co;
            fundName = (_item$sfdrStrategy$fu = item.sfdrStrategy.fund) === null || _item$sfdrStrategy$fu === void 0 ? void 0 : _item$sfdrStrategy$fu.name;
            if (item.sfdrStrategy.kind === SfdrStrategyKind.EsCharacteristic) groupInfo = $i18n.t('kpi.group.esCharacteristics');else groupInfo = "".concat($i18n.t('kpi.group.sustainableObjective'), " '").concat((_item$sfdrStrategy$co = item.sfdrStrategy.concept) === null || _item$sfdrStrategy$co === void 0 ? void 0 : _item$sfdrStrategy$co.label, "'");
          }
          break;
        case TypeAggregationGroup.KfwMinimumReporting:
          groupInfo = $i18n.t('kpi.group.KfwMinimumReporting');
          break;
        case TypeAggregationGroup.KfwRecommendedReporting:
          groupInfo = $i18n.t('kpi.group.KfwRecommendedReporting');
          break;
        case TypeAggregationGroup.KfwFullReporting:
          groupInfo = $i18n.t('kpi.group.KfwFullReporting');
          break;
        case TypeAggregationGroup.AllSustainable:
          groupInfo = $i18n.t('kpi.group.AllSustainable');
          break;
        case TypeAggregationGroup.AllEnvironmental:
          groupInfo = $i18n.t('kpi.group.AllEnvironmental');
          break;
        case TypeAggregationGroup.AllEuTaxonomyAligned:
          groupInfo = $i18n.t('kpi.group.AllEuTaxonomyAligned');
          break;
        case TypeAggregationGroup.AllEuTaxonomyAlignedFossilGas:
          groupInfo = $i18n.t('kpi.group.AllEuTaxonomyAlignedFossilGas');
          break;
        case TypeAggregationGroup.AllEuTaxonomyAlignedNuclear:
          groupInfo = $i18n.t('kpi.group.AllEuTaxonomyAlignedNuclear');
          break;
        case TypeAggregationGroup.AllEuTaxonomyAlignedNoFossilGasNoNuclear:
          groupInfo = $i18n.t('kpi.group.AllEuTaxonomyAlignedNoFossilGasNoNuclear');
          break;
        case TypeAggregationGroup.AllEuTaxonomyAlignedEnabling:
          groupInfo = $i18n.t('kpi.group.AllEuTaxonomyAlignedEnabling');
          break;
        case TypeAggregationGroup.AllEuTaxonomyAlignedTransitional:
          groupInfo = $i18n.t('kpi.group.AllEuTaxonomyAlignedTransitional');
          break;
        // default:
        //   console.log(`No group name for ${item.groupType}.`)
      }
      return groupInfo ? "".concat(fundName, " - ").concat(groupInfo) : fundName;
    };
    var editMetricDialog = ref({});
    var handleMetricUpsert = function handleMetricUpsert() {
      Object.keys(editMetricDialog.value).forEach(function (key) {
        editMetricDialog.value[Number(key)] = false;
      });
    };
    return {
      __sfc: true,
      props: props,
      $i18n: $i18n,
      $nuxt: $nuxt,
      accountResult: accountResult,
      account: account,
      userResult: userResult,
      user: user,
      expandPeriods: expandPeriods,
      filteredCategoryIds: filteredCategoryIds,
      filteredSectionIds: filteredSectionIds,
      defaultPeriods: defaultPeriods,
      periods: periods,
      getMetricDefaultReportingPeriodType: getMetricDefaultReportingPeriodType,
      useTargetFromFilters: useTargetFromFilters,
      options: options,
      expanded: expanded,
      showDebugging: showDebugging,
      headers: headers,
      insertPeriodHeaders: insertPeriodHeaders,
      selectedCategoryIdsForFilter: selectedCategoryIdsForFilter,
      selectedIncludesUncategorized: selectedIncludesUncategorized,
      selectedSectionIdsForFilter: selectedSectionIdsForFilter,
      variables: variables,
      loading: loading,
      result: result,
      refetch: refetch,
      categoryCounts: categoryCounts,
      sectionCounts: sectionCounts,
      itemCount: itemCount,
      items: items,
      deleteMetricAggregation: deleteMetricAggregation,
      updateMetricAggregation: updateMetricAggregation,
      groupName: groupName,
      editMetricDialog: editMetricDialog,
      handleMetricUpsert: handleMetricUpsert,
      getSafe: getSafe,
      TypeAggregationGroup: TypeAggregationGroup
    };
  }
});